export class AppConstants {
    static reportsURL = 'item_tracking/get_item_data';
    static exportURL = 'item_tracking/export_item_data';
    static dateLimitURL = 'item_tracking/get_date_limit';
}